/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import VariationOptions from '../../../Quote/Step05/components/VariationOptions'
import VariationOptionss from '../../../Quote/Step05c/components/VariationOptions'
import VariationOptionsMuseums from '../../../Quote/Step05m/components/VariationOptions'
import VariationOptionsDealers from '../../../Quote/Step05d/components/VariationOptions'
import VariationOptionsCp from '../../../Quote/Step05cp/components/VariationOptions'

export default class CoverOptions extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            optionsOpen: true,
        }
    }

    toggleOptionsOpen = () => this.setState({ optionsOpen: !this.state.optionsOpen })

    render() {
        const { isCollectors, isMuseums, isDealersStock, isWineSpirits, isCommercialProperty, quoteType } =
            this.props

        return (
            <div
                className={
                    `mta__other quote__form mta__coverOptions quote__form__group 
                    ${(isCollectors || isMuseums || isDealersStock || isWineSpirits || isCommercialProperty) ?
                        `step5cOptions` : ``} `
                }
            >
                {(isCollectors || isWineSpirits) ?
                    <VariationOptionss
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    /> : isMuseums ? <VariationOptionsMuseums
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    /> : isDealersStock ? <VariationOptionsDealers
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    /> : (isCommercialProperty && quoteType === 'hiscox') ? <VariationOptionsCp
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    /> : <VariationOptions
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    />

                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/CoverOptions.tsx